import "material-design-icons-iconfont/dist/material-design-icons.css" // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify";
import ru from "vuetify/es5/locale/ru";
import en from "vuetify/es5/locale/en";

import "@fontsource/inter"
import "@fontsource/inter/400.css" // Specify weight
import "@fontsource/inter/500.css" // Specify weight and style
import "@fontsource/inter/600.css" // Specify weight and style
import "@fontsource/inter/700.css" // Specify weight and style
import "@fontsource/inter/800.css" // Specify weight and style
import "@fontsource/inter/900.css" // Specify weight and style

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: "md"
    },
    lang: {
        locales: {ru, en},
        current: "ru"
    }
});
